import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import style from "../../../css/dashboard/Screener.module.css";

import debounce from "lodash.debounce";
import { fetch_screener_stocks, fetch_live_price } from "../../ApisService/apiService";

const Screenerhistory = () => {
    const [screenerData, setScreenerData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedStrategy, setSelectedStrategy] = useState("");
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const observerRef = useRef(null);
    const [livePrices, setLivePrices] = useState({});

    useEffect(() => {
        fetchScreenerData(selectedStrategy, page);
    }, [selectedStrategy, page]);

    const fetchScreenerData = debounce(async (strategy, page) => {
        if (page > 6) return;

        setLoading(true);
        try {
            const response = await fetch_screener_stocks(strategy, page);
            if (response.length === 0) {
                setHasMore(false);
            } else {
                setScreenerData((prev) => (page === 1 ? response : [...prev, ...response]));
                fetchLivePrices(response);
            }
        } catch (error) {
            console.error("Error fetching screener data:", error);
        }
        setLoading(false);
    }, 500);

    const fetchLivePrices = async (stocksData) => {
        const prices = {};
        for (const stock of stocksData) {
            try {
                const priceData = await fetch_live_price(stock.code);
                if (priceData.live_price) {
                    const livePrice = priceData.live_price.BIDPRICE || 0;
                    const openPrice = priceData.live_price.OPEN || 0;
                    const percentageChange = openPrice
                        ? ((livePrice - openPrice) / openPrice) * 100
                        : 0;
                    prices[stock.code] = {
                        livePrice,
                        percentageChange,
                    };
                }
            } catch (error) {
                console.error(`Error fetching price for ${stock.code}:`, error);
            }
        }
        setLivePrices(prices);
    };

    const handleSearch = debounce((query) => {
        setSearchQuery(query);
    }, 300);

    const handleStrategyChange = (strategy) => {
        setSelectedStrategy(strategy);
        setPage(2); // Reset to page 2 on strategy change
        setScreenerData([]); // Clear existing data
    };

    // Get unique strategies for dropdown
    const strategyList = [
        "VPC SETUP",
        "ROCKET BASE",
        "IPO BASE",
        "FNO SETUP"
    ];

    useEffect(() => {
        if (!hasMore) return;
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    setPage((prev) => (prev < 5 ? prev + 1 : prev)); // Stop at page 5
                }
            },
            { root: null, rootMargin: "200px", threshold: 0.5 }
        );

        if (observerRef.current) observer.observe(observerRef.current);
        return () => observer.disconnect();
    }, [screenerData.length, hasMore]);

    return (
        <div className={style.screenercontainer}>
            {/* Search & Strategy Filter */}
            {/* <div className={style.controls}>
                <input
                    type="text"
                    placeholder="Search company or code..."
                    className={style.searchBar}
                    onChange={(e) => handleSearch(e.target.value)}
                />
                <select className={style.strategyFilter} onChange={(e) => handleStrategyChange(e.target.value)} value={selectedStrategy}>
                    <option value="">All Strategies</option>
                    {strategyList.map((strategy, index) => (
                        <option key={index} value={strategy}>{strategy}</option>
                    ))}
                </select>
            </div>

            {loading && <p className={style.loading}>Loading data...</p>} */}
            <AnimatePresence>
                <div className={style.marketInsightsContainer}>
                    <h1>Stock Performance</h1>
                    <div className={style.marketInsightsTable}>
                        <div className={style.tableWrapper}>
                            <table className={style.screenerTable}>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Company</th>
                                        <th>Symbol</th>
                                        <th>Industry</th>
                                        <th>Price</th>
                                        <th>Change</th>
                                        <th>Result</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {screenerData.length > 0 ? (
                                        screenerData.map((stock, index) => {
                                            const priceData = livePrices[stock.code] || {};
                                            const { livePrice = "N/A", percentageChange = 0 } = priceData;
                                            const isUp = percentageChange > 0;

                                            return (
                                                <tr key={stock.id} className={style.row}>
                                                    <td>{index + 1}</td>
                                                    <td className={style.companyName}>{stock.name}</td>
                                                    <td>{stock.symbol}</td>
                                                    <td>{stock.industry}</td>
                                                    <td>₹{livePrice}</td>
                                                    <td className={isUp ? style.greenText : style.redText}>
                                                        {percentageChange.toFixed(2)}%{" "}
                                                        <i className={`fas ${isUp ? "fa-arrow-up" : "fa-arrow-down"}`}></i>
                                                    </td>
                                                    <td style={{ fontWeight: "bold", color: stock.trade_result === "Profit" ? "green" : "red" }}>
                                                        {stock.trade_result} {stock.percentage}%
                                                    </td>
                                                    <td>{new Date(stock.created_at).toLocaleDateString()}</td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="9" className={style.noData}>No data available</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </AnimatePresence>

            <div ref={observerRef}></div>
        </div>
    );
};

export default Screenerhistory;
